
export default {
  productData: {
    serialNumber: 'DA-MME-007',
    name: 'Massivholzdecke mit Estrich l Aufbau 7',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '210', value: 210
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '62 (-2; 0)',
        value: 62
      },
      soundReductionIndex: { // Rw
        output: '58 (-2; -8)',
        value: 58
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,48',
        value: 0.48
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '210 [kg/m²]'
      }
    }
  },
  image: 'da-mme-007.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-7-DA-MME-007-Rev01.pdf'
}
